// Rounter
import { BrowserRouter } from "react-router-dom";
import AppRoute from "./Route/AppRoute";
import QueryProviderClient from "./react-query/query-provider";
import { Toaster } from "./components/ui/sonner";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect } from "react";
import { AuthInitializer } from "./components/auth/AuthInitializer";
import ScrollRestorationOff from "./components/ScrollRestorationOff";

// Gsap
gsap.registerPlugin(ScrollTrigger);

function App(): JSX.Element {
  // ScrollTrigger Refresh
  useEffect(() => {
    const timeout = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {/* userdata - get */}
      <AuthInitializer />

      {/* Query Provideer */}
      <QueryProviderClient>
        <BrowserRouter>
          <AppRoute />
        </BrowserRouter>

        {/* sonner */}
        <Toaster richColors theme="dark" />
      </QueryProviderClient>
    </>
  );
}

export default App;
